import React, { Component } from 'react';

import {
    Container,
    Row,
    Col,
    FormGroup, Label, Input,
    Button,
    Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';



import moment from 'moment';

import Isvg from 'react-inlinesvg';
import xIcon from '../../../assets/svg/x.svg';

import fullscreenIcon from '../../../assets/svg/fullscreen-icon.svg'


import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
} from 'chart.js';

import { Pie, Bar, Line, Chart } from 'react-chartjs-2';
import { GRAPH_COLORS } from './colorHelper';





ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController
);


class PieGraph extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,

        };
    }




    componentDidMount() {
        if (this.props.getGraphImage) {
            this.props.getGraphImage(this.getGraphImage)
        }
        if (this.props.getDatasets) {
            this.props.getDatasets(this.getDatasets)
        }

    }
    componentDidUpdate(prevProps, prevState) {

    }

    componentWillUnmount() {
        this.ref = null;
    }

    getGraphImage = () => {
        if (this.ref && this.ref?.toBase64Image?.()) {
            return this.ref.toBase64Image();
        }
    }
    getDatasets = () => {
        if (!this.props.data?.length) {
            return null;
        }
        let datasets = [];
        const backgroundColors = this.props.data?.filter(item => item.backgroundColor)?.length === this.props.data?.length ? this.props.data?.map(item => item.backgroundColor) : GRAPH_COLORS?.slice(0, this.props.data?.length);
        const labels = this.props.data?.map((item) => item.name) || [];
        const values = this.props.data?.map((item) => item.value) || [];

        if (values?.length) {
            for (let i = 0; i < values?.length; i++) {
                let obj = {
                    label: labels?.[i],
                    value: values?.[i],
                    backgroundColor: backgroundColors?.[i],
                }
                datasets.push(obj);
            }
        }
        datasets = datasets?.sort((a, b) => {
            return b.value - a.value;
        });
        return datasets;
    }



    render() {
        // const data = this.props.data;
        if (!this.props.data?.length) {
            return null;
        }
        const backgroundColors = this.props.data?.filter(item => item.backgroundColor)?.length === this.props.data?.length ? this.props.data?.map(item => item.backgroundColor) : GRAPH_COLORS?.slice(0, this.props.data?.length);

        const options = {
            animation: {
                duration: 0
            },
            responsive: true,
            plugins: {
                legend: {
                    display: false
                }
            }
        }
        const data = {
            labels: this.props.data?.map((item) => {
                let label = item.name;
                if (label === 'Unassigned') label = 'Unassigned'.translate(this.props.lang);
                return label;
            }) || [],
            datasets: [
                {
                    label: '',
                    data: this.props.data?.map((item) => item.value) || [],
                    backgroundColor: backgroundColors,
                    borderWidth: 0
                },
            ],
        };

        return (
            <div key={this.props.key} className="pie-graph-container">
                <Pie
                    ref={(node) => {
                        this.ref = node;
                    }}
                    options={options}
                    data={data}
                />


            </div>
        );


    }
}
export default PieGraph;